// extracted by mini-css-extract-plugin
export default {"Card":"ProductsPage_Card__OA5DK"};